import { render, staticRenderFns } from "./PendingRoyaltyReports.vue?vue&type=template&id=7838ef52"
import script from "./PendingRoyaltyReports.vue?vue&type=script&lang=js"
export * from "./PendingRoyaltyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports